import { selectComponentDefinitions } from "./groupDefinitions";

export const commerceComponents = selectComponentDefinitions([
    "Expected Delivery",
    "Up Selling",
    "Selectable Upsells",
    "Payment Methods",
]);
